module.exports = __webpack_public_path__ + "2458795d7841f2c84835dea91345f427.svg";